module.exports = __webpack_public_path__ + "static/media/location.e752b3d8.svg";